import { authStore, useAuth, useAuthStore, useMfaIntent } from '@jq4race/api-client';
import type { ReactNode } from 'react';

import { AuthStateContext } from '../modules/auth/ui/auth-state-context';

interface AuthStateProviderProps {
  children: ReactNode;
}

export function AuthStateProvider({ children }: AuthStateProviderProps) {
  const {
    session,
    isAuthenticated,
    sessionExpired,
    sessionExpiredReason,
    setSession,
    clearSessionExpired,
    expireSession,
    signOut,
  } = useAuth();
  const { mfaIntent, setMfaIntent } = useMfaIntent();

  return (
    <AuthStateContext.Provider
      value={{
        session,
        isAuthenticated,
        mfaIntent,
        sessionExpired,
        sessionExpiredReason,
        setSession,
        setMfaIntent,
        clearSessionExpired,
        expireSession,
        signOut,
        getSession: () => authStore.get(),
        getMfaIntent: () => useAuthStore.getState().mfaIntent,
      }}
    >
      {children}
    </AuthStateContext.Provider>
  );
}
